import {useState} from "react";
import AdminProfileService from "../services/api";

const useAdminProfileUtils = () => {
    const [isFetchingProfileTypes, setFetchingProfileTypes] = useState(false);
    const [profileTypes, setProfileTypes] = useState([]);
    const [isFetchingIDTypes, setFetchingIDTypes] = useState(false);
    const [idTypes, setIDTypes] = useState([]);
    const [isFetchingProfileStatus, setFetchingProfileStatus] = useState(false);
    const [profileStatusList, setProfileStatusList] = useState([]);


    const getProfileTypesUtil = () => {
        setFetchingProfileTypes(true);

        AdminProfileService.getProfileTypes().then((res) => {
            console.log("getProfileTypes data xxxx", res);

            if (res.data.success) {
                setProfileTypes(res.data.data);
                setFetchingProfileTypes(false);
            }

        }).catch((error) => {
            console.error("Error fetching profile types:", error);
            
            setFetchingProfileTypes(false);
            setProfileTypes([]);
        })
    }

    const getIDTypesUtil = () => {
        setFetchingIDTypes(true);

        AdminProfileService.getIDTypes().then((res) => {
            console.log("getIDTypes data xxxx", res);

            if (res.data.success) {
                setIDTypes(res.data.data);
                setFetchingIDTypes(false);
            }

        }).catch((error) => {
            console.error("Error fetching ID types:", error);
            
            setFetchingIDTypes(false);
            setIDTypes([]);
        })
    }

    const getProfileStatusUtil = () => {
        setFetchingProfileStatus(true);

        AdminProfileService.getProfileStatus().then((res) => {
            console.log("getProfileStatus data xxxx", res);

            if (res.data.success) {
                setProfileStatusList(res.data.data);
                setFetchingProfileStatus(false);
            }

        }).catch((error) => {
            console.error("Error fetching profile status:", error);
            
            setFetchingProfileStatus(false);
            setProfileStatusList([]);
        })
    }

    return {
        isFetchingProfileTypes,
        profileTypes,
        getProfileTypesUtil,

        isFetchingIDTypes,
        idTypes,
        getIDTypesUtil,

        isFetchingProfileStatus,
        profileStatusList,
        getProfileStatusUtil
    }
}

export default useAdminProfileUtils